module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_Secado.4661fd8b.pdf";